//React Library
import React, { useState, useEffect } from "react";

//Material UI Styles
import { makeStyles } from "@material-ui/core/styles";

//Material UI Components
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import MuiPhoneNumber from "material-ui-phone-number";
import Visibility from "@material-ui/icons/Visibility";
import FormControl from "@material-ui/core/FormControl";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import CustomToolTip from "../../Global/PasswordGuileline";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import DeleteIcon from "@material-ui/icons/Delete";
import TableRow from "@material-ui/core/TableRow";
import { Switch } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";

//Global Elements
import GlobalApi from "../../Global";
import Colors from "../../Global/colors";
import refresh_token from "../../Global/refresh_token";
import { useTranslation } from "react-i18next";

//Custom Css + Images
import "./planYourAudits.css";
import swal from "@sweetalert/with-react";
import publicLibN from "../../Assets/public_libraray_normal.png";
import publicLibH from "../../Assets/public_libraray_over.png";
import templateN from "../../Assets/template_normal.png";
import templateH from "../../Assets/template_over.png";
import uploadN from "../../Assets/upload_ur_normal.png";
import uploadH from "../../Assets/upload_ur_over.png";
import existingN from "../../Assets/use_existing_normal.png";
import existingH from "../../Assets/use_existing_over.png";
import Edit from "../../Assets/edit.png";

//Redux
import { addTeam } from "../../Redux/Actions/teamAction";
import { useSelector, useDispatch } from "react-redux";

//Router
import { Redirect } from "react-router";
import { useHistory } from "react-router-dom";

//Others
import uuid from "react-uuid";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  input: {
    display: "none",
  },
  textField: {
    backgroundColor: Colors.globalColor5,
    border: "none",
    borderRadius: 5,
  },
  resize: {
    padding: "7px",
  },
  password: {
    padding: "2px",
  },
  switchBase: {
    color: "#818181",
    padding: "1px",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#043077",
      },
    },
  },
  thumb: {
    color: "white",
    width: "20px",
    height: "20px",
    margin: "1px",
  },
  track: {
    borderRadius: "20px",
    width: "200px",
    backgroundColor: "#818181",
    opacity: "1 !important",
    "&:after, &:before": {
      color: "white",
      fontSize: "11px",
    },
    "&:after": {
      content: "'activate'",
      left: "7px",
    },
    "&:before": {
      content: "'deactivate'",
      right: "8px",
    },
  },
  checked: {
    color: "#043077 !important",
    transform: "translateX(50px) !important",
  },
}));

function PlanYourAudits({isOnboarding=false}) {
  const {t} = useTranslation();
  const [currentCompany, setCurrentCompany] = useState("");
  const [permissions_obj, setPermissionObj] = useState({});
  const [packageDetails, setPackageDetails] = useState(null);
  const history = useHistory();

  var blank_template = [
    {
      id: uuid(),
      title: "Title Page",
      type: "fixed section",
      position: 1,
      status: "New",

      checklist: {
        template: { id: uuid() },
        list: [
          {
            id: "New-" + uuid(),
            title: "Conducted on",
            dataType: "DateTime",
            position: 1,
            status: "New",
            responseLibrary: [],
            mandatory: false,
            multiselection: false,
            condition: "",
            conditionValue: "",
            conditional: "no",
            parent: null,
            isopen: "no",
            conditionalList: [],
          },
          {
            id: "New-" + uuid(),
            title: "Prepared by",
            dataType: "Text field",
            position: 2,
            status: "New",
            responseLibrary: [],
            mandatory: false,
            multiselection: false,
            condition: "",
            conditionValue: "",
            conditional: "no",
            parent: null,
            isopen: "no",
            conditionalList: [],
          },
          {
            id: "New-" + uuid(),
            title: "Location",
            dataType: "Location",
            position: 3,
            status: "New",
            responseLibrary: [],
            mandatory: false,
            multiselection: false,
            condition: "",
            conditionValue: "",
            conditional: "no",
            parent: null,
            isopen: "no",
            conditionalList: [],
          },
        ],
      },
    },
    {
      id: uuid(),
      title: "Inspection",
      type: "section",
      position: 2,
      status: "New",
      checklist: {
        template: { id: uuid() },
        list: [
          {
            id: "New-" + uuid(),
            title: "",
            dataType: "Text field",
            position: 1,
            status: "New",
            responseLibrary: [],
            mandatory: false,
            multiselection: false,
            condition: "",
            conditionValue: "",
            conditional: "no",
            parent: null,
            isopen: "no",
            conditionalList: [],
          },
        ],
      },
    },
  ];

  let company = useSelector((state) => state.companyReducer.company);
  let userData = useSelector((state) => state.userReducer.user);
  useEffect(
    () => {
      setCurrentCompany(company);
      getPermissions();
    },
    [company?.id]
  );

  const getPermissions = () => {
    console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data !== null) {
      let params = { company_id: company?.id, user_id: data?.user_id };
      let query = Object.keys(params)
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");

      fetch(GlobalApi + "/User/get_user_permission_of_company?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((responseJson) => responseJson.json())
        .then(async (response) => {
          console.log(response);
          if (response.msg === "success") {
            let permissionsObj = {};
            await response.data.map((v) => {
              permissionsObj[(v?.title)] = true;
            });
            console.log("Permissions Obj >>>>>>>", permissionsObj);

            setPermissionObj(permissionsObj);
          } else if (
            response.error === "jwt expired" ||
            response.error === "invalid token" ||
            response.error === "invalid signature" ||
            response.error === "jwt malformed" ||
            response.error === "Unexpected token"
          ) {
            let status = await refresh_token();
            // console.log(status);
            if (status) {
              // console.log("opopopop");
              getPermissions();
            }
          }
        })
        .catch((error) => {
          // localStorage.clear();
          // window.location.replace("/signin");
          console.log("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF", error.message);
        });
    }
  };

  useEffect(() => {
    getPackageDetails();
  }, []);

  const getPackageDetails = async () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data == undefined) {
      return <Redirect to={"/signin"} />;
    }
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();

  
    if (reqJson?.package?.license?.status === "expired" || reqJson?.package?.license?.status === "deactive") {
      history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
    }
  };

  //Custom Template Code

  const addSection = (
    title,
    template_id,
    user,
    checklist,
    token,
    type,
    position
  ) => {
    var obj = {
      title: title,
      template_id: template_id,
      status: "active",
      created_by: user,
      type: type,
      position: position,
    };
    var token = token;
    console.log("create section Api called");
    fetch(GlobalApi + "/Section/create_section", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log("response from create Section", res);
        if (res.status === "Success") {
          //===================== Add checklist===============//
          await checklist.map((item) => {
            //alert(JSON.stringify(item.responseLibrary.responses))
            // if (item.status == "New")
            addChecklistItem(
              item.title,
              res.data.id,
              user,
              item.position,
              item.dataType,
              token,
              item.responseLibrary,
              item.mandatory,
              item.multiselection,
              item.condition,
              item.conditionValue,
              item.conditional,
              item.parent,
              item.conditionalList,
              item.type,
              item.is_subquestion,
              item.subQuestionList,
            );
          });

          //==================================================//
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            addSection(title, template_id, user, checklist, token);
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  const addChecklistItem = (
    title,
    section_id,
    user,
    position,
    dataType,
    token,
    responseLibrary,
    mandatory,
    multiselection,
    condition,
    conditionValue,
    conditional,
    parent,
    conditionalList,
    type,
    is_subquestion,
    subQuestionList,
  ) => {
    var obj = {
      title: title,
      section_id: section_id,
      status: "active",
      created_by: user,
      position: position,
      data_type: dataType,
      is_mandatory: mandatory,
      is_multiple_allowed: multiselection,
      condition: condition,
      condition_value: conditionValue,
      is_conditional: conditional,
      parent_id: parent,
      type:type,
      is_subquestion:is_subquestion,
    };
    var token = token;
    console.log("create checklist api called");
    fetch(GlobalApi + "/CheckList/create_check_list", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log("response of create checklist", res);
        if (res.status === "Success") {
          //===================== Add checklist===============//
          if (dataType == "Custom" || dataType == "Global") {
            await responseLibrary.responses.map((r, index) => {
              addResponseLibrary(
                r.title,
                res.data.id,
                r.id,
                user,
                token,
                index == 0 ? true : false
              );
            });
          }
          //==================================================//
          //===================== Add Conditional checklist===============//
          if (conditional == "yes") {
            conditionalList.map((item) => {
              // if (item.status == "New")
              addChecklistItem(
                item.title,
                section_id,
                user,
                item.position,
                item.dataType,
                token,
                item.responseLibrary,
                item.mandatory,
                item.multiselection,
                item.condition,
                item.conditionValue,
                item.conditional,
                res.data.id,
                item.type,
                item.is_subquestion,
                item.subQuestionList,
              );

              if (item.status == "changed" || item.status == "deleted") {
              }
              // updateChecklistItem(
              //   item.title,
              //   section_id,
              //   user,
              //   item.position,
              //   item.dataType,
              //   token,
              //   item.responseLibrary,
              //   item.status,
              //   item.id,
              //   item.mandatory,
              //   item.multiselection,
              //   item.condition,
              //   item.conditionValue,
              //   item.conditional,
              //   item.parent
              // );
            });
          }

          if (is_subquestion == "yes") {
            subQuestionList.map((item) => {
              // if (item.status == "New")
              addChecklistItem(
                item.title,
                section_id,
                user,
                item.position,
                item.dataType,
                token,
                item.responseLibrary,
                item.mandatory,
                item.multiselection,
                item.condition,
                item.conditionValue,
                item.conditional,
                res.data.id,
                item.type,
                item.is_subquestion,
                item.subQuestionList,
              );

              
            });
          }

          //==================================================//
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            addChecklistItem(
              title,
              section_id,
              user,
              position,
              dataType,
              token,
              responseLibrary,
              mandatory,
              multiselection,
              condition,
              conditionValue,
              conditional,
              parent,
              conditionalList, 
              type,
              is_subquestion,
              subQuestionList,
            );
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  const addResponseLibrary = (
    title,
    check_id,
    response_id,
    user,
    token,
    status
  ) => {
    var obj = {
      title: title,
      check_id: check_id,
      response_id: response_id,
      status: "active",
      created_by: user,
      delete: status,
    };
    var token = token;
    console.log("create response library api called");
    fetch(GlobalApi + "/ResponseSet/create_response_set", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log("response of create response set", res);
        if (res.status === "Success") {
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            addResponseLibrary(title, check_id, response_id, user, token);
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  console.log("packageDetails", packageDetails)

  const createCustomTemplate = async (template) => {
    if (
      packageDetails?.template_limit == "Unlimited" ||
      parseInt(packageDetails?.template_limit) > packageDetails?.template_count
    ) {
      if (
        userData?.super_admin == true ||
        permissions_obj["Admin"] == true ||
        permissions_obj["Template Creation"] == true
      ) {
        var retrievedData = localStorage.getItem("UserData");
        var data = JSON.parse(retrievedData);
        if (data.token == null) {
          return <Redirect to={"/signin"} />;
        }

        var user = data.user_id;
        var obj = {
          title: "Untitled Template",
          company_id: currentCompany.id,
          description: "Add Description",
          status: "draft",
          created_by: user,
        }; //organization_id:'408576c3-0471-467e-9f55-f4c44bb54c6e',
        console.log("create template APi called");

        var token = data.token;
        fetch(GlobalApi + "/Template/create_template", {
          method: "post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify(obj),
        })
          .then((response) => response.json())
          .then(async (res) => {
            console.log("response of create template", res);
            if (res.msg === "success") {
              console.log("create template share APi called");
              fetch(GlobalApi + "/TemplateShare/create_template_share", {
                method: "post",
                headers: new Headers({
                  Authorization: "Bearer " + token,
                  "Content-Type": "application/json",
                }),
                body: JSON.stringify({
                  user_id: user,
                  company_id: res.data.organization_id,
                  template_id: res.data.id,
                  isOwner: true,
                  isEditor: true,
                }),
              });
              await blank_template.map(async (section) => {
                // if (section.status == "New")
                await addSection(
                  section.title,
                  res.data.id,
                  user,
                  section.checklist.list,
                  token,
                  section.type,
                  section.position
                );
              });
              // setTimeout(async () => {
              //   this.setState({ templateId: res.data.id });
              // }, 3000);

              console.log("template id im sending", res.data.id);

              history.push({
                pathname: "/show",
                state: { action: "edit", templateId: res.data.id },
              });
            } else if (
              res.error === "jwt expired" ||
              res.error === "invalid token" ||
              res.error === "invalid signature" ||
              res.error == "Unexpected token"
            ) {
              let status = await refresh_token();
              console.log(status);
              if (status) {
                console.log("opopopop");
                this.handleBack();
              }
            }
          })
          .catch((err) => {
            console.log(err, "error");
          });
      } else {
        swal(
          t("Warning"),
          t("You Do Not Have Permission to Create Templates"),
          "warning"
        );
      }
    } else {
      swal(t("Warning"), t("Package Limit Reached!. Upgrade Package"), "warning");
    }
  };

  return (
    <div
    className={isOnboarding == true ? "scrollHidden" : ""}
      style={{
        width: "100%",
        padding:isOnboarding == true ? (window.innerWidth > 500 ? "20px 1px 20px 20px" : "10px 1px 10px 10px") : "20px",
        overflowY: "auto",
        backgroundColor: Colors.globalColor9,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: isOnboarding == true ? "50vh" : "78vh",
        }}
      >
        {window.innerWidth > 700 && <Grid
          container
          xs={12}
          sm={12}
          lg={8}
          spacing={3}
          justifyContent="center"
          textAlign="center"
          style={{display:'flex', textAlign:'center', justifyContent:'center' }}
        >
          <Grid item xs={12} sm={4} lg={3} style={{ cursor: "pointer" }}>
            <div
              className="Box hover"
              justifyContent="center"
              textAlign="center"
              onClick={() => createCustomTemplate()}
            >
              <div style={{  display: "flex", flexDirection:'column', justifyContent: "center", padding: "auto", alignItems: "center", height:'100%' }}>
                <img
                  src={templateH}
                  width="80px"
                  // onMouseOver={(e) => (e.currentTarget.src = templateH)}
                  // onMouseOut={(e) => (e.currentTarget.src = templateN)}
                />
                <p className="label1" style={{marginBottom:0, marginTop:'5px'}}>Custom Template</p>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={4} lg={3} style={{ cursor: "pointer" }}>
            <div
              className="Box hover"
              justifyContent="center"
              textAlign="center"
              onClick={() => history.push("/template/public")}
            >
               <div style={{  display: "flex", flexDirection:'column', justifyContent: "center", padding: "auto", alignItems: "center", height:'100%' }}>
                <img
                  src={publicLibH}
                  width="80px"
                  id="img1"
                  // onMouseOver={(e) => (e.currentTarget.src = publicLibH)}
                  // onMouseOut={(e) => (e.currentTarget.src = publicLibN)}
                />
                <p className="label1" style={{marginBottom:0, marginTop:'5px'}}>Public Library</p>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={4} lg={3} style={{ cursor: "pointer" }}>
            <div
              className="Box hover"
              justifyContent="center"
              textAlign="center"
              onClick={() => history.push("/template")}
            >
               <div style={{  display: "flex", flexDirection:'column', justifyContent: "center", padding: "auto", alignItems: "center", height:'100%' }}>
                <img
                  src={existingH}
                  width="80px"
                  // onMouseOver={(e) => (e.currentTarget.src = existingH)}
                  // onMouseOut={(e) => (e.currentTarget.src = existingN)}
                />
                 <p className="label1" style={{marginBottom:0, marginTop:'5px'}}>Use Existing</p>
              </div>
            </div>
          </Grid>
          {/* <Grid item xs={3} style={{ cursor: "pointer" }}>
            <div
              className="Box hover"
              justifyContent="center"
              textAlign="center"
            >
               <div style={{  display: "flex", flexDirection:'column', justifyContent: "center", padding: "auto", alignItems: "center", height:'100%' }}>
                <img
                  src={uploadN}
                  width="80px"
                  onMouseOver={(e) => (e.currentTarget.src = uploadH)}
                  onMouseOut={(e) => (e.currentTarget.src = uploadN)}
                />
                <p className="label1" style={{marginBottom:0, marginTop:'5px'}}>Upload Your Own</p>
              </div>
            </div>
          </Grid> */}
          
        </Grid>}

        {window.innerWidth > 500 && window.innerWidth <= 700 && <Grid
          container
          xs={12}
          sm={12}
          lg={8}
          spacing={2}
          justifyContent="center"
          textAlign="center"
          style={{display:'flex', textAlign:'center', justifyContent:'center' }}
        >
          <Grid item xs={12} sm={4} lg={3} style={{ cursor: "pointer" }}>
            <div
              className="Box hover"
              justifyContent="center"
              textAlign="center"
              onClick={() => createCustomTemplate()}
            >
              <div style={{  display: "flex", flexDirection:'column', justifyContent: "center", padding: "auto", alignItems: "center", height:'100%' }}>
                <img
                  src={templateH}
                  width="80px"
                  // onMouseOver={(e) => (e.currentTarget.src = templateH)}
                  // onMouseOut={(e) => (e.currentTarget.src = templateN)}
                />
                <p className="label1" style={{marginBottom:0, marginTop:'5px'}}>Custom Template</p>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={4} lg={3} style={{ cursor: "pointer" }}>
            <div
              className="Box hover"
              justifyContent="center"
              textAlign="center"
              onClick={() => history.push("/template/public")}
            >
               <div style={{  display: "flex", flexDirection:'column', justifyContent: "center", padding: "auto", alignItems: "center", height:'100%' }}>
                <img
                  src={publicLibH}
                  width="80px"
                  id="img1"
                  // onMouseOver={(e) => (e.currentTarget.src = publicLibH)}
                  // onMouseOut={(e) => (e.currentTarget.src = publicLibN)}
                />
                <p className="label1" style={{marginBottom:0, marginTop:'5px'}}>Public Library</p>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={4} lg={3} style={{ cursor: "pointer" }}>
            <div
              className="Box hover"
              justifyContent="center"
              textAlign="center"
              onClick={() => history.push("/template")}
            >
               <div style={{  display: "flex", flexDirection:'column', justifyContent: "center", padding: "auto", alignItems: "center", height:'100%' }}>
                <img
                  src={existingH}
                  width="80px"
                  // onMouseOver={(e) => (e.currentTarget.src = existingH)}
                  // onMouseOut={(e) => (e.currentTarget.src = existingN)}
                />
                 <p className="label1" style={{marginBottom:0, marginTop:'5px'}}>Use Existing</p>
              </div>
            </div>
          </Grid>
          {/* <Grid item xs={3} style={{ cursor: "pointer" }}>
            <div
              className="Box hover"
              justifyContent="center"
              textAlign="center"
            >
               <div style={{  display: "flex", flexDirection:'column', justifyContent: "center", padding: "auto", alignItems: "center", height:'100%' }}>
                <img
                  src={uploadN}
                  width="80px"
                  onMouseOver={(e) => (e.currentTarget.src = uploadH)}
                  onMouseOut={(e) => (e.currentTarget.src = uploadN)}
                />
                <p className="label1" style={{marginBottom:0, marginTop:'5px'}}>Upload Your Own</p>
              </div>
            </div>
          </Grid> */}
          
        </Grid>}

        {window.innerWidth <= 500 && <Grid
          container
          xs={12}
          sm={12}
          lg={8}
          spacing={1}
          justifyContent="center"
          textAlign="center"
          style={{display:'flex', textAlign:'center', justifyContent:'center' }}
        >
          <Grid item xs={12} sm={4} lg={3} style={{ cursor: "pointer" }}>
            <div
              className="Box hover"
              justifyContent="center"
              textAlign="center"
              onClick={() => createCustomTemplate()}
            >
              <div style={{  display: "flex", flexDirection:'column', justifyContent: "center", padding: "auto", alignItems: "center", height:'100%' }}>
                <img
                  src={templateH}
                  width="80px"
                  // onMouseOver={(e) => (e.currentTarget.src = templateH)}
                  // onMouseOut={(e) => (e.currentTarget.src = templateN)}
                />
                <p className="label1" style={{marginBottom:0, marginTop:'5px'}}>Custom Template</p>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={4} lg={3} style={{ cursor: "pointer" }}>
            <div
              className="Box hover"
              justifyContent="center"
              textAlign="center"
              onClick={() => history.push("/template/public")}
            >
               <div style={{  display: "flex", flexDirection:'column', justifyContent: "center", padding: "auto", alignItems: "center", height:'100%' }}>
                <img
                  src={publicLibH}
                  width="80px"
                  id="img1"
                  // onMouseOver={(e) => (e.currentTarget.src = publicLibH)}
                  // onMouseOut={(e) => (e.currentTarget.src = publicLibN)}
                />
                <p className="label1" style={{marginBottom:0, marginTop:'5px'}}>Public Library</p>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={4} lg={3} style={{ cursor: "pointer" }}>
            <div
              className="Box hover"
              justifyContent="center"
              textAlign="center"
              onClick={() => history.push("/template")}
            >
               <div style={{  display: "flex", flexDirection:'column', justifyContent: "center", padding: "auto", alignItems: "center", height:'100%' }}>
                <img
                  src={existingH}
                  width="80px"
                  // onMouseOver={(e) => (e.currentTarget.src = existingH)}
                  // onMouseOut={(e) => (e.currentTarget.src = existingN)}
                />
                 <p className="label1" style={{marginBottom:0, marginTop:'5px'}}>Use Existing</p>
              </div>
            </div>
          </Grid>
          {/* <Grid item xs={3} style={{ cursor: "pointer" }}>
            <div
              className="Box hover"
              justifyContent="center"
              textAlign="center"
            >
               <div style={{  display: "flex", flexDirection:'column', justifyContent: "center", padding: "auto", alignItems: "center", height:'100%' }}>
                <img
                  src={uploadN}
                  width="80px"
                  onMouseOver={(e) => (e.currentTarget.src = uploadH)}
                  onMouseOut={(e) => (e.currentTarget.src = uploadN)}
                />
                <p className="label1" style={{marginBottom:0, marginTop:'5px'}}>Upload Your Own</p>
              </div>
            </div>
          </Grid> */}
          
        </Grid>}
      </div>
    </div>
  );
}

export default PlanYourAudits;
